import {observer} from "mobx-react";
import type {User} from "../../../../data/models/User";
import {XyiconFeature} from "../../../../generated/api/base";
import {useAppStore} from "../../../../StateManager";
import {SelectInputV5} from "../../input/select/SelectInputV5";
import type {IInputPropsV5} from "../../../widgets/input/clicktoedit/InputUtils";
import {renderItemWithInitials} from "../../sharing/ItemWithInitials";
import {compareUsers, renderUserValue} from "../../../../data/models/field/datatypes/PeopleSingle";
import {HorizontalAlignment} from "../../../../utils/dom/DomUtils";
import {SingleSelectDropdownFixedWidth, SingleSelectDropdownMaxHeight} from "./SingleSelectInputV5";

interface IPeopleSingleChoiceInputV5Props extends IInputPropsV5 {
	runOnClickEvenWhenDisabled?: boolean;
}

export const PeopleSingleChoiceInputV5 = observer((props: IPeopleSingleChoiceInputV5Props) => {
	const {value, onChange} = props;
	const appState = useAppStore((state) => state.appState);
	const allUsers = appState.actions.getList<User>(XyiconFeature.User).toSorted(compareUsers);
	const selectedUserMaybe = value as User;

	return (
		<SelectInputV5
			{...props}
			selected={selectedUserMaybe}
			options={allUsers}
			nullOption={true}
			nullLabel="-"
			placeholder="-"
			isSameWidth={false}
			fullWidth={true}
			dropdownMaxHeight={`${SingleSelectDropdownMaxHeight}px`}
			dropdownFixedWidth={`${SingleSelectDropdownFixedWidth}px`}
			horizontalAlignment={props.inline ? HorizontalAlignment.center : undefined}
			optionStyle={{minHeight: "48px"}}
			renderOptionWhenClosed={(item: User) => renderItemWithInitials(item, "small")}
			renderOptionWhenOpen={(item: User) => renderItemWithInitials(item, "big")}
			stringifyOption={renderUserValue}
			onChange={(userMaybe: User) => onChange(userMaybe?.id ?? null)}
		/>
	);
});
